export class ItemParameter {
    public name: string | undefined;
    public valueDouble: string | undefined;
    public valueString: string | undefined;
    public measurement: string | undefined;

}

export class ItemParameterDTO{
    public n: string | undefined;
    public d: string | undefined;
    public s: string | undefined;
    public m: string | undefined;

}
